<div class="legend-container">
  <div class="legend-items">
    <!-- Items with flag=false (before separator) -->
    <ng-container *ngFor="let item of itemsBeforeSeparator">
      <div
        class="legend-item"
        [class.interactive]="isInteractive"
        (click)="toggleItem(item)">
        <div
          class="legend-circle"
          [class.not-activated]="isDeactivated(item)"
          [style.backgroundColor]="isDeactivated(item) ? null : getColorValue(item)">
          <span *ngIf="isDeactivated(item)" class="slash-line"></span>
        </div>
        <span class="legend-label">{{ getLabel(item) }}</span>
      </div>
    </ng-container>

    <!-- Separator (only show if both groups have items) -->
    <span *ngIf="itemsBeforeSeparator.length && itemsAfterSeparator.length" class="separator">|</span>

    <!-- Items with flag=true (after separator) -->
    <ng-container *ngFor="let item of itemsAfterSeparator">
      <div
        class="legend-item"
        [class.interactive]="isInteractive"
        [class.deactivated]="isDeactivated(item)"
        (click)="toggleItem(item)">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM3.3916 9.66602C4.12752 10.1906 5.02741 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 5.02741 10.1906 4.12752 9.66602 3.3916L3.3916 9.66602ZM6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 6.97104 1.809 7.86923 2.33203 8.60449L8.60449 2.33203C7.86923 1.809 6.97104 1.5 6 1.5Z" fill="#D11044"/>
        </svg>
        <span class="legend-label">{{ getLabel(item) }}</span>
      </div>
    </ng-container>
  </div>
</div>
